import { render, staticRenderFns } from "./detail-loader.vue?vue&type=template&id=68d1c8a6&scoped=true&"
import script from "./detail-loader.vue?vue&type=script&lang=js&"
export * from "./detail-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1c8a6",
  null
  
)

export default component.exports